<hbo-datatable-smart *ngIf="users$ | async as users" [columns]="columns" [items]="users" (reload)="searchUsers($event)"
  [typeData]="'usersList'"
  [showTeamFilter]="true"
  [teams_filter]="teams">
  <tbody class=" table-group-divider accordion" id="accordionUser">
  <ng-container *ngFor="let user of usersCollection$">
    <tr class="accordion-header">
      <th scope="row"><button class="accordion-button collapsed" data-bs-toggle="collapse"
          [attr.data-bs-target]="'#collapse-' + user.id"> </button></th>
      <td>{{ user.id }}</td>
      <td>{{ user.fullname | titlecase }}</td>
      <td>{{ user.email }}</td>
      <td>{{ user.username }}</td>
      <td>{{ user.entity.name | titlecase }}</td>
      <td>{{ 'ROLE.' + user.role?.id | translate }}</td>
      <td>{{ ('PROFILE.' + user.profileId | translate) }}</td>
      <td *ngIf="currentUser.roleId === 1">{{ (user.roleId !== 1) ? '-' : ((user.horizonsTeam?.name | titlecase) ??
        ('COMMON.ALL' | translate)) }}</td>
      <td *ngIf="(currentUser.roleId === 1 || currentUser.roleId === 2) || currentUser.roleId === 3">
        {{ user.roleId === 1 ? '-' : ((user.calculatedTeamName) ?? ('COMMON.ALL' | translate)) }}
      </td>
    </tr>
    <tr class="row-body">
      <td colspan="10" class="bg-light p-0">
        <div [id]="'collapse-' + user.id" class="accordion-collapse collapse" data-bs-parent="#accordionUser">
          <div class="accordion-body">
            <hbo-user-actions [user]="user" (reload)="searchUsers()"
              [selectorVisible]="openedRow === 'collapse-' + user.id" (callback)="callback($event)"></hbo-user-actions>
          </div>
        </div>
      </td>
    </tr>
  </ng-container>
  <tr *ngIf="!users.data.length">
    <td colspan="9" class="text-center">{{ 'COMMON.NO_RESULTS' | translate }}</td>
  </tr>
  </tbody>
</hbo-datatable-smart>